import { useState, useEffect, useContext, useCallback } from 'react';
import { useFormik } from 'formik';
import { AuthContext } from '../../../../context/authContext';
import alumnosApiService from '../../../../services/http/alumnosApiService';
import { httpServiceInstanceNode } from '../../../../services/http/httpService';
import { getItem, STORAGE_KEYS } from '../../../../services/storage';
import { NON_OPTION_CENTRO } from '../constants';
import config from '../../../../config';

export default function useDatosEscolares({
  prevActiveTab,
  datosEscolares,
  missingDataFunction,
  userId,
  datosPersonales,
}) {
  const { empresaId } = getItem(STORAGE_KEYS.STUDENT) ?? {};
  const { userOU } = useContext(AuthContext);
  const { idCedesca, idCntec, centro } = userOU;

  const [isModalShown, setIsModalShown] = useState(false);
  const [isModalShown2, setIsModalShown2] = useState(false);
  const [formationCenter, setFormationCenter] = useState('');
  const [academicFormation, setAcademicFormation] = useState('');
  const [studiesList, setStudiesList] = useState('');
  const [studiesList2, setStudiesList2] = useState('');
  const [sitLaboralList, setSitLaboralList] = useState([]);
  const [lastStudiesList, setLastStudiesList] = useState('');
  const [yearsApi, setYearsApi] = useState('');
  const [raw, setRaw] = useState('');
  const [url, setUrl] = useState('');
  const [nese, setNese] = useState('');

  const validate = useCallback(
    (values) => {
      const errors = {};
      if (values.idioma === '') {
        errors.idioma = 'Obligatorio';
        missingDataFunction(true);
      }
      if (!values.sede) {
        errors.sede = 'Obligatorio';
        missingDataFunction(true);
      }
      if (
        values.notaMedia.toString().length > 0 &&
        !/^\d*\.?\d+$/i.test(values.notaMedia)
      ) {
        errors.notaMedia = 'Debe ser un valor decimal separado por un punto';
        missingDataFunction(true);
      }
      if (!values.siguientesEstudios) {
        errors.siguientesEstudios = 'Obligatorio';
        missingDataFunction(true);
      }
      if (values.formaAcceso === '') {
        errors.formaAcceso = 'Obligatorio';
        missingDataFunction(true);
      }
      return errors;
    },
    [missingDataFunction],
  );

  const saveData = useCallback(
    async (values, whitModal = true) => {
      const empresa = getItem(STORAGE_KEYS.STUDENT)?.empresaId;
      const lastUpdate = new Date();
      let isUpdated = 0;

      try {
        const data = await alumnosApiService.comprobarActualizacion({
          empresaId: empresa,
          alumno: userId,
          date: lastUpdate,
        });
        isUpdated = data;

        if (isUpdated === 0) {
          setIsModalShown(true);
        } else {
          const urlToGo = `${config.REACT_APP_NODE_API}actualizarUsuarioEscolares?empresaId=${
            getItem(STORAGE_KEYS.STUDENT)?.empresaId
          }`;
          const rawData = {
            id: userId,
            idioma: values.idioma,
            idalu: values.idalu,
            sede: values.sede,
            nee: values.nee,
            tsi: values.tsi,
            neeComment: values.neeComment,
            situacionLaboral: values.situacionLaboral,
            formacionAcademica: values.formacionAcademica,
            antiguoCentro: values.antiguoCentro,
            antiguosEstudios: values.antiguosEstudios,
            notaMedia: values.notaMedia,
            siguientesEstudios: values.siguientesEstudios,
            formaAcceso: values.formaAcceso,
            emailCorp: values.emailCorp,
            fechaUltimoCurso: values.fechaUltimoCurso,
            fechaTitulo: values.fechaTitulo,
            headquarter: getItem(STORAGE_KEYS.STUDENT)?.empresaId,
          };

          if (whitModal) {
            setRaw(rawData);
            setUrl(urlToGo);
            setIsModalShown2(true);
          } else {
            await httpServiceInstanceNode.post(urlToGo, rawData);
          }
        }
      } catch (error) {
        // No hacer nada específico aquí.
      }
    },
    [userId],
  );

  const formik = useFormik({
    initialValues: {
      id: userId,
      idioma:
        datosEscolares.idioma === '' || datosEscolares.idioma === null
          ? 'Español'
          : datosEscolares.idioma,
      idalu: datosEscolares.idalu === null ? '' : datosEscolares.idalu,
      sede: datosEscolares.sede === null ? '' : datosEscolares.sede,
      nee: datosEscolares.nee === null ? '' : datosEscolares.nee,
      tsi: datosEscolares.tsi === null ? '' : datosEscolares.tsi,
      neeComment: datosEscolares.neeComment === null ? '' : datosEscolares.neeComment,
      situacionLaboral:
        datosEscolares.situacionLaboral === null ? '' : datosEscolares.situacionLaboral,
      formacionAcademica:
        datosEscolares.formacionAcademica === null ? '' : datosEscolares.formacionAcademica,
      antiguoCentro: datosEscolares.antiguoCentro === null ? '' : datosEscolares.antiguoCentro,
      antiguosEstudios:
        datosEscolares.antiguosEstudios === null ? '' : datosEscolares.antiguosEstudios,
      notaMedia: datosEscolares.notaMedia === null ? '' : datosEscolares.notaMedia,
      siguientesEstudios:
        datosEscolares.siguientesEstudios === null ? '' : datosEscolares.siguientesEstudios,
      formaAcceso: datosEscolares.formaAcceso === null ? '' : datosEscolares.formaAcceso,
      emailCorp: datosEscolares.emailCorp === null ? '' : datosEscolares.emailCorp,
      fechaUltimoCurso:
        datosEscolares.fechaUltimoCurso === null ? '' : datosEscolares.fechaUltimoCurso,
      fechaTitulo: datosEscolares.fechaTitulo === null ? '' : datosEscolares.fechaTitulo,
      ...datosEscolares,
    },
    validateOnChange: false,
    validate,
    onSubmit: (values) => saveData(values, true),
  });

  useEffect(() => {
    const cargarOpciones = async () => {
      try {
        const dataNese = await alumnosApiService.obtenerOpcionesNese({ empresaId: 'CEDESCA' });
        setNese([{ Id: '-1', tipo: '', tipo_cast: '', codigo: '' }, ...dataNese]);
      } catch (error) {
        setNese('');
      }

      try {
        const dataCentros = await alumnosApiService.cargarCentrosFormacion({
          empresaId: 'CEDESCA',
        });
        const sedes = dataCentros.filter(
          (c) => c.Poblacion && String(c.Poblacion).trim() !== '',
        );
        if (datosPersonales.centroNombre === 'CAMPUS ACADEMIA') {
          const filteredData = sedes.filter(
            (entry) => entry.Nombre === 'CAMP JOLIU' || entry.Nombre === 'CEDESCA',
          );
          setFormationCenter([NON_OPTION_CENTRO, ...filteredData]);
        } else {
          setFormationCenter([NON_OPTION_CENTRO, ...sedes]);
        }
      } catch (error) {
        setFormationCenter('');
      }

      try {
        const dataAEscolares = await alumnosApiService.cargarAEscolares({
          empresaId,
          headquarter: empresaId,
        });
        const arrayFiltrado = [...dataAEscolares];
        arrayFiltrado.unshift({ Id: '-1', Valor: '', Valor2: '' });
        setYearsApi(arrayFiltrado);
      } catch (error) {
        setYearsApi('');
      }

      try {
        const dataEstudios2 = await alumnosApiService.cargarEstudios({
          empresaId,
          procedence: '1',
        });
        setStudiesList2([
          { Id_Estudio: 0, Estudio: '', Estudio_cast: '', Codigo_Estudios: 0 },
          ...dataEstudios2,
        ]);
      } catch (error) {
        setStudiesList2('');
      }

      try {
        const dataEstudios = await alumnosApiService.cargarEstudios({ empresaId });
        setStudiesList([
          { Id_Estudio: 0, Estudio: '', Estudio_cast: '', Codigo_Estudios: 0 },
          ...dataEstudios,
        ]);
      } catch (error) {
        setStudiesList('');
      }

      try {
        const dataUltimosEstudios = await alumnosApiService.cargarUltimosEstudios({
          empresaId,
        });
        setLastStudiesList(dataUltimosEstudios);
      } catch (error) {
        setLastStudiesList('');
      }

      try {
        const dataFormacionesAcademicas = await alumnosApiService.cargarFormacionesAcademicas({
          empresaId,
        });
        const arrayFiltrado = [...dataFormacionesAcademicas];
        arrayFiltrado.unshift({ Id: '-1', id: '-1', Nombre: '', Valor: '' });
        setAcademicFormation(arrayFiltrado);
      } catch (error) {
        setAcademicFormation('');
      }

      try {
        const dataSituacionLaboral = await alumnosApiService.cargarSituacionLaboral({
          empresaId,
        });
        setSitLaboralList(dataSituacionLaboral);
      } catch (error) {
        setSitLaboralList([]);
      }
    };

    cargarOpciones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fecha = new Date(datosEscolares.fechaTitulo);
    formik.setValues({
      ...formik.values,
      fechaTitulo: fecha,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    formik.validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const exec = async () => {
      try {
        if (prevActiveTab === '2') {
          if (formik.dirty) await saveData(formik.values, false);
        } else {
          formik.resetForm({ values: formik.values });
        }
      } catch (error) {
        // No hacer nada específico aquí.
      }
    };
    exec();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevActiveTab]);

  useEffect(() => {
    if (formationCenter.length > 0 && idCedesca > 0 && idCntec > 0) {
      const centroEncontrado = formationCenter.find((c) => c.Nombre === centro);
      formik.setValues((prev) => ({
        ...prev,
        sede: centroEncontrado?.Poblacion || '',
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formationCenter, centro, idCedesca, idCntec]);

  const handleFechaTitulos = (value) => {
    formik.setValues((prev) => ({ ...prev, fechaTitulo: value }));
  };

  return {
    formik,
    userOU,
    idCedesca,
    idCntec,
    centro,
    formationCenter,
    academicFormation,
    studiesList,
    studiesList2,
    sitLaboralList,
    lastStudiesList,
    yearsApi,
    nese,
    isModalShown,
    isModalShown2,
    raw,
    url,
    setUrl,
    setIsModalShown2,
    handleFechaTitulos,
  };
}
